/* This file contains additional helping functions */

// Handle errors TODO: Need to improve this function
const handleErrors = (error, type) => {
	let errorMsg = handleValidationErrors(error, type)
	if (errorMsg != '') {
		return errorMsg
	} else {
		return error
	}
}

// Handle Validation errors is function to handle errors from backend if there is validation error
const handleValidationErrors = (error, type) => {
	let errorMessage = ''
	let validationProps = []

	let validationErrors = error.response.data.error
	switch (type) {
		case 'login':
			validationProps = ['email', 'password']
			break
		case 'register':
			validationProps = ['email', 'password', 'name']
			break
		case 'forgotPassword':
			validationProps = ['email']
			break
		case 'resetPassword':
			validationProps = ['email', 'password']
			break
		case 'userCreate':
			validationProps = ['email', 'password', 'name']
			break
		case 'userUpdate':
			validationProps = ['name']
			break
		case 'userAvatar':
			validationProps = ['avatar']
			break
		case 'carnivore':
			validationProps = ['name']
			break
		case 'roleStore':
			validationProps = ['name']
			break
		case 'dnsRecord2':
			validationProps = ['name', 'content', 'type']
			break
	}

	if (error.response.data.error) {
		validationProps.forEach(prop => {
			if (validationErrors[prop]) {
				errorMessage += ' ' + validationErrors[prop]
			}
		})
	}

	if (type === 'login' && error.response.data.message) {
		errorMessage = error.response.data.message
	}

	return errorMessage
}

// Format numbers using device locale
function formatNumberLocale(value) {
	if (typeof value === 'number') {
		return value.toLocaleString();
	}
	if (typeof value === 'string' && value !== '' && !isNaN(value) && isFinite(value)) {
		return Number(value).toLocaleString();
	}
	return value;
}

export { handleErrors, formatNumberLocale }
